import React from 'react';
import { DictionaryType } from '../../types';
import { AlertTriangle, X } from 'lucide-react';

interface DeleteConfirmModalProps {
  type: DictionaryType | null;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (type: DictionaryType) => void;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  type,
  isOpen,
  onClose,
  onConfirm,
}) => {
  if (!isOpen || !type) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '1rem',
      }}
    >
      <div
        style={{
          backgroundColor: '#ffffff',
          borderRadius: '0.75rem',
          maxWidth: '420px',
          width: '100%',
          padding: '1.25rem',
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'var(--action-danger)' }}>
            <AlertTriangle size={24} />
            <h3 style={{ fontSize: '1.125rem', fontWeight: 700, margin: 0 }}>Xác nhận xóa từ điển</h3>
          </div>
          <button onClick={onClose} style={{ color: 'var(--text-muted)' }}>
            <X size={20} />
          </button>
        </div>

        <p style={{ fontSize: '0.875rem', color: 'var(--text-main)', marginBottom: '1.25rem', lineHeight: 1.5 }}>
          Bạn có chắc chắn muốn xóa toàn bộ dữ liệu từ điển <strong>{type}</strong> không? Hành động này sẽ xóa vĩnh viễn dữ liệu trong IndexedDB và không thể hoàn tác.
        </p>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
          <button
            onClick={onClose}
            style={{
              padding: '0.5rem 1rem',
              borderRadius: '0.375rem',
              border: '1px solid var(--border-light)',
              backgroundColor: '#ffffff',
              color: 'var(--text-main)',
              fontWeight: 500,
              fontSize: '0.875rem',
            }}
          >
            Hủy bỏ
          </button>

          <button
            onClick={() => {
              onConfirm(type);
              onClose();
            }}
            className="btn-danger"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.375rem',
              fontSize: '0.875rem',
            }}
          >
            Xóa vĩnh viễn
          </button>
        </div>
      </div>
    </div>
  );
};
